// extracted by mini-css-extract-plugin
module.exports = {"majorContainer":"PopularBar_majorContainer__2xwhA","optionslist":"PopularBar_optionslist__11pHa","options":"PopularBar_options__2lyDm"};